class WishlistCount extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setCountFromStorage()
  }

  setupListeners () {
    super.setupListeners()

    this.onWishlistChanged = this.onWishlistChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.CHANGED,
      this.onWishlistChanged,
    )
  }

  onWishlistChanged () {
    this.setCountFromStorage()
  }

  setCountFromStorage () {
    const count =
      typeof localStorage.iWishCnt !== 'undefined' ? localStorage.iWishCnt : 0

    this.dataset.count = count
    this.textContent = count
  }
}

if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount)
}
